import CloudAccountNew from './CloudAccountNew';

export default CloudAccountNew;
